export default __webpack_public_path__ + "static/media/Jeromy Gride.445842ae.jpg";